import { LocationYears } from 'models/ActivityDataLocationYears/locationYears.model';
import { Address } from 'models/Address/address.model';
import { serializable, alias, primitive, list, object } from 'serializr';

export class Location {

    @serializable
    id?: number;

    @serializable(alias('location_name', primitive()))
    locationName?: string;

    @serializable(alias('location_category', primitive()))
    locationCategory?: string;

    @serializable(alias('organization_id', primitive()))
    organizationId?: string;

    @serializable(alias('years_with_scope_status', list(object(LocationYears))))
    yearsWithScopeStatus?: LocationYears[];

    @serializable(alias('location_address', object(Address)))
    location?: Address;

}